import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '../environments/environment';

export const devTools = [
  StoreDevtoolsModule.instrument({
    maxAge: 50, // Retains last 25 states
    logOnly: environment.production, // Restrict extension to log-only mode
    autoPause: true,
    // monitor: (state, action) => {
    //   if (action?.action) {
    //     console.log(action.action?.type, action.action);
    //   }
    // },
    connectInZone: true,
  }),
];
